import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import Sidebar from "../sidenav/Sidenav";
import {
  Button,
  Table,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import isDesktop from "../isDesktop";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { tableCellClasses } from "@mui/material/TableCell";
import { hasStoredTabAccess } from '../utils/access';

const BrandsMobile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
  const [brandsData, setBrandsData] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageData, setImageData] = useState("");
  const [brandOrder, setBrandOrder] = useState("");
  const isDesktopDevice = isDesktop();
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isOpen, setIsOpen] = useState({
    add: false,
    update: false,
  });

  const isAuthorized = hasStoredTabAccess('Rewards');

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell component="th" scope="row">
            <div>{row?.id}</div>
          </TableCell>
          <TableCell component="th" scope="row">
            <div>{row?.brand_name}</div>
          </TableCell>
          <TableCell style={{ textAlign: "end" }}>
            <IconButton
              aria-label="expand row"
              style={{ color: "black" }}
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow
          sx={{
            "& td": { border: 0, height: open ? "auto" : 0 },
            borderBottom: "1px solid black",
          }}
        >
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, borderTop: "none" }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <div
                style={{
                  fontSize: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "0.5rem",
                }}
              >
                <div style={{ flex: "1" }}>Actions:</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                  }}
                >
                  <Button
                    onClick={() => {
                      onVoucherClick(row?.id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#D1F4DE",
                      color: "black",
                    }}
                  >
                    Voucher
                  </Button>
                  <Button
                    onClick={() => {
                      onEditClick(row?.id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#D1F4DE",
                      color: "black",
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      onBrandDelete(row?.id);
                    }}
                    className="actionMobileBtn"
                    style={{
                      backgroundColor: "#FFD6D2",
                      color: "black",
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const onAddClick = () => {
    setIsOpen((prev) => ({
      ...prev,
      add: true,
    }));
  };

  const fetchBrandsData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/all`
      );

      setBrandsData(response.data.data);
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  console.log(brandsData, "brands data");

  useEffect(() => {
    fetchBrandsData();
  }, []);

  const onVoucherClick = (id) => {
    return navigate(`vouchers/${id}`);
  };

  const onEditClick = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/${id}`
      );

      const data = response.data.data;
      setBrandName(data.brand_name);
      setBrandOrder(data.brand_order);
      setSelectedBrandId(id);
      setImageUrl(data.icon_url);
      setIsOpen((prev) => ({
        ...prev,
        update: true,
      }));
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };
  const handleImageUploadToS3Link = async (imageData) => {
    let imageResponse;
    if (imageData) {
      imageResponse=await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/file/upload`,
        imageData,
        {headers: {
          'Content-Type': 'multipart/form-data',
        }}
      )
    }
    return imageResponse.data.imageUrl;
  }
  const onBrandUpdate = async () => {
    try {
      const imageUrl = await handleImageUploadToS3Link(imageData);
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/${selectedBrandId}`,
        {
          brandOrder: brandOrder,
          brandName: brandName,
          iconUrl: imageUrl,
        }
      );
      if (response.status == 200) {
        toast.success("Data updated Successfully");
        handleDialogClose();
        fetchBrandsData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  const onBrandAdd = async () => {
    try {
      const imageUrl = await handleImageUploadToS3Link(imageData);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand`,
        {
          brandOrder: brandOrder,
          brandName: brandName,
          iconUrl: imageUrl,
        }
      );

      if (response.status == 200) {
        toast.success("Data added successfully");
        handleDialogClose();
        fetchBrandsData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };

  const onBrandDelete = (id) => {
    setSelectedBrandId(id);
    setDeleteOpen(true);
  };

  const handleDialogClose = () => {
    setBrandName("");
    setBrandOrder("");
    setImageUrl("");
    setIsOpen({
      add: false,
      update: false,
    });
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/rewards/brand/${selectedBrandId}`
      );
      if (response.status == 200) {
        toast.success("Data updated Successfully");
        setDeleteOpen(false);
        fetchBrandsData();
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.error);
    }
  };
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    const formData = new FormData();
    formData.append("image", selected);
    setImageData(formData);
    setImageUrl(URL.createObjectURL(selected));
  }
  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{ marginTop: "2rem" }}>
          You are unauthorized to access this page
        </h2>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0.5rem 0.75rem 1.25rem 0.75rem",
        }}
      >
        <div
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "36px",
            height: "36px",
            borderRadius: "18px",
            background: "#EAF1F7",
          }}
        >
          <Hemberger />
        </div>
        <Link to={"/profile"}>
          <UserIcon style={{ cursor: "pointer" }} />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0rem 0.75rem 1.5rem 0.75rem",
        }}
      >
        <div className="container-fluid" style={{margin: 0, padding: 0}}>
          <div
          style={{
            display:"flex",
            justifyContent:"space-between",
            marginBottom:"2.25rem"
          }}
          >
          <div
            style={{
              display: "flex",
              gap: "1vw",
              alignItems: "center",
              // marginBottom:"2.25rem"
            }}
          >
            <ArrowBackIosNewRounded
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            />
            <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
              Rewards
            </h4>
          </div>
          <Button
            onClick={onAddClick}
            className="button-two"
            style={{ width: "6rem", height: "1.75rem", background: "#37446F" }}
          >
            Add
          </Button>
          </div>
          <Table
            aria-label="collapsible table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <TableHead
              style={{
                height: "44px",
                borderRadius: "4px !important",
                background: "rgba(234, 241, 247, 1)",
                boxShadow: "2px 2px 4px 0px rgba(174, 174, 192, 0.5)",
              }}
            >
              <TableRow>
                <TableCell>S. No.</TableCell>
                <TableCell>Brand Name</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {brandsData?.map((brand, ind) => (
                <Row key={ind} row={brand} />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <Dialog open={isOpen.add || isOpen.update} onClose={handleDialogClose}>
        <DialogTitle style={{ fontWeight: "600" }}>
          {isOpen.add ? "Add New brand" : "Update brand"}
        </DialogTitle>
        <DialogContent>
          <TextField
            name="name"
            type="text"
            fullWidth
            className="mt-3"
            label="Brand Name"
            value={brandName}
            onChange={(e) => {
              setBrandName(e.target.value);
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                  boxShadow: "none",
                },
              },
            }}
            InputLabelProps={{
              sx: { "&.Mui-focused": { color: "#A8A8A8" } },
              required: false,
            }}
            InputProps={{
              style: {
                boxShadow:
                  "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
              },
            }}
          />
          <TextField
            name="order"
            type="text"
            fullWidth
            className="mt-3"
            label="Brand Order"
            value={brandOrder}
            onChange={(e) => {
              setBrandOrder(e.target.value);
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                  boxShadow: "none",
                },
              },
            }}
            InputLabelProps={{
              sx: { "&.Mui-focused": { color: "#A8A8A8" } },
              required: false,
            }}
            InputProps={{
              style: {
                boxShadow:
                  "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
              },
            }}
          />
          {/* <TextField
            name="order"
            type="text"
            fullWidth
            className="mt-3"
            label="Image Url"
            value={imageUrl}
            onChange={(e) => {
              setImageUrl(e.target.value);
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "transparent",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                  boxShadow: "none",
                },
              },
            }}
            InputLabelProps={{
              sx: { "&.Mui-focused": { color: "#A8A8A8" } },
              required: false,
            }}
            InputProps={{
              style: {
                boxShadow:
                  "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
              },
            }}
          /> */}
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center', margin: '0.5rem auto'}}>
            {imageUrl && 
              <img src={imageUrl} alt="Brand Image" style={{width: '5.208rem', height: '3.7rem',objectFit: 'contain'}} />
            }
            <Button variant="outlined" component="label">
              Upload Image
              <input type="file" hidden accept="image/*" onChange={handleFileChange} />
            </Button>
          </div>
        </DialogContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1.282vw",
            padding: "24px",
            paddingTop: "0",
          }}
        >
          <Button
            className="outlined-button"
            style={{ flex: "1", width: "auto !important" }}
            onClick={() => {
              handleDialogClose();
            }}
          >
            Cancel
          </Button>
          <Button
            className="filled-button"
            style={{ flex: "1", width: "auto !important" }}
            onClick={() => {
              isOpen.add ? onBrandAdd() : onBrandUpdate();
            }}
          >
            {isOpen.add ? "Add" : "Update"}
          </Button>
        </div>
      </Dialog>
      <Dialog
        open={deleteOpen}
        onClose={(prev) => !prev}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ textAlign: "center" }}
      >
        <ErrorOutlineIcon
          style={{ color: "red", fontSize: "32px", margin: "12px auto" }}
        />
        <DialogTitle
          id="alert-dialog-title"
          style={{ fontSize: "18px", fontWeight: "500", lineHeight: "0" }}
        >
          {"Are you Sure?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ fontSize: "12px" }}
          >
            You won't be able to revert this!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteOpen(false)}
            style={{
              textTransform: "none",
              width: "120px",
              height: "36px",
              border: "2.03px solid #37446F",
              borderRadius: "5.85px",
              background: "none",
              color: "black",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            style={{
              textTransform: "none",
              width: "120px",
              height: "36px",
              borderRadius: "5.85px",
              background: "#37446F",
              color: "white",
            }}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BrandsMobile;
